<template>
    <div>

    </div>
</template>

<script>
export default {
    name: '',
    components: {},
    props: {},
    data () {
        return {}
    },
    computed: {},
    created () {},
    methods: {}
}
</script>

<style lang="scss" scoped>

</style>